export const calculateTextWidth = (text, fontStyle, padding=0) => {
  const el = document.createElement("span");
  el.innerText = text;
  el.className = "preset-text";
  Object.assign(el.style, fontStyle);
  window.document.body.appendChild(el);
  const v = Math.ceil(el.getBoundingClientRect().width);
  window.document.body.removeChild(el);
  return v + padding + "px";
};